export default {
  ON_VIDEOS: 1,
  BELOW_VIDEOS: 2,
};



// WEBPACK FOOTER //
// ./src/default-settings/info-position-values.js